import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { black, greyDark, red, white, blue, greyF7 } from "../../styles/variables";

const { spacing } = theme;

export const disabled = css`
  input:read-only {
    color: rgba(0, 0, 0, 0.38);
  }
`;

export const emptyFileBlock = css`
  width: 100%;
  padding-top: ${spacing(3)}px;
  padding-bottom: ${spacing(3)}px;
  color: ${greyDark};

  &.MuiTypography-root {
    font-size: 14px;
  }
`;

export const errorFileBlock = css`
  color: ${red};
`;

export const exclamationIcon = css`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  margin-right: ${theme.spacing(1)}px;
  background-color: ${red};
  color: ${white};
  vertical-align: middle;
`;

export const fileBlock = css`
  display: flex;
  align-items: center;
  color: ${black};
  background-color: ${greyF7};
  border-radius: 4px;
  padding: ${theme.spacing(1, 3, 1, 1)};

  > div {
    width: 45%;

    &:last-child {
      width: 10%;
    }
  }
`;

export const fileField = css`
  display: flex;
  align-items: center;
  overflow: hidden;
  word-break: break-all;
`;

export const hoverFile = css`
  &:hover {
    cursor: pointer;
    border-bottom: 1px solid black;
  }
`;

export const actionField = css`
  text-align: right;
`;

export const closeButton = css`
  &.MuiSvgIcon-root {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

export const selectFileButton = {
  borderColor: blue,
  color: blue,
};

export const emptyIcon = css`
  width: 60px;
  height: 60px;
  margin-bottom: ${theme.spacing(1)}px;
  color: ${greyDark};
`;

export const emptyText = css`
  color: ${greyDark};
`;

export const button = css`
  margin-top: 24px;
`;

export const link = css`
  text-decoration: none;
`;
